import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import type { TermedLevel } from '../../common/termedLevel/types';

export function BookingOverviewRemainingDays({ contract }: { contract: TermedLevel }) {
    if (contract.startsAt && !contract.endsAt) {
        return <span>∞</span>;
    }
    if (contract.remainingDays === undefined) {
        return <span>–</span>;
    }
    const remainingDays = Math.max(0, contract.remainingDays);
    return (
        <span className={classNames({ 'text-color-warning text-medium': contract.criticalRemainingDays })}>
            {remainingDays}{' '}
            <FormattedMessage
                id={
                    remainingDays === 1
                        ? 'intl-msg:marketplace.durationUnit.day'
                        : 'intl-msg:marketplace.durationUnit.days'
                }
            />
        </span>
    );
}
